var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"}},[_c('feather-icon',{staticClass:"cursor-pointer",staticStyle:{"color":"#7367f0"},attrs:{"icon":"SearchIcon","svgClasses":"w-5 h-5"},on:{"click":_vm.cariEkstre}})],1)]),_c('HomeSiparisDetay',{ref:"siparisCek"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }